<template>
  <front-regular-modal ref="warningModal"
                       :title="$t('title')"
                       width="650px"
                       @closed="onClosed" :click-to-close="true"
                       class="new-contacts-pending-news-modal"
  >
    <div class="body-text">
      <dl>
        <dt>{{$t('Выпуск карты')}}</dt>
        <dd>
          <div class="striked">2.25 USD</div> 1.75 USD
        </dd>
        <dt>{{$t('Пополнение карты')}}</dt>
        <dd>
          <div class="striked">3.5%</div> 3%
        </dd>
        <dt>
          {{$t('Ежемесячное обслуживание')}}
        </dt>
        <dd>
          <div class="striked">2.7 USD</div> 0 USD
        </dd>
        <dt>
          {{$t('Плата за транзакцию')}}
        </dt>
        <dd>
          <div class="striked">0.5 USD</div> 0 USD
        </dd>
      </dl>
    </div>
    <template v-slot:footer>
      <div class="modal-buttons">
<!--        <button type="button" @click.prevent="clickCancel"-->
<!--                class=" btn btn-default">{{ $t('Напомнить позже') }}-->
<!--        </button>-->
        <div></div>
        <button type="button" @click.prevent="clickOk" class="btn btn-success">
          {{ $t('Закрыть') }}
        </button>
      </div>
    </template>
  </front-regular-modal>
</template>

<script lang="ts" setup>
import FrontRegularModal from "@/views/pages/global/modals/FrontRegularModal.vue";
import Cookies  from "js-cookie";
import {ref, onMounted, computed} from "vue";
import moment from "moment";

const COOKIE_NAME = 'NewIntercashUsaFeesAlert';
import axiosHelper from "webapp-react/src/shared/axios.helper";

const props = defineProps({
  enabled: {
    type: Boolean,
    default: false
  },

})

const localStorageSupported = ref(true);
const warningModal = ref(null)

const showMessage = () => {
  if (warningModal.value)
    (warningModal.value as FrontRegularModal).showModal();
}

const hideMessage = () => {
  if (warningModal.value)
    (warningModal.value as FrontRegularModal).hideModal();
}


const clickCancel = () => {
  rememberCancelForAwhile();
  hideMessage();
}
const clickOk = () => {
  rememberCancelForAwhile();
  hideMessage();
  // window.location.href = '/cards/issue';
}

const checkLocalStorageSupportedCached = ref(null);

const checkLocalStorageSupported = () => {
  if (checkLocalStorageSupportedCached.value !== null)
    return checkLocalStorageSupportedCached.value;
  try {
    localStorage.setItem(`${COOKIE_NAME}_test`, COOKIE_NAME);
    localStorage.removeItem(`${COOKIE_NAME}_test`);
    return checkLocalStorageSupportedCached.value = true;
  } catch (e) {
    return checkLocalStorageSupportedCached.value = false;
  }
}

const randomSleep = (min: number = 0, max: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, Math.random() * (max - min) + min);
  })
}

const whoami = async (): Promise<User | null> => {
  try {
    await randomSleep(500, 1500);
    const {data: {user}}: {
      data: { user: User }
    } = await axiosHelper.get('/webapi/profile/whoami?m[mode]=requisites');
    // console.log('whoami user', user);
    return user;
  } catch (e) {
    return null;
  }
}

type User = {
  username: string
  email: string
  mobile?: string
  contacts: {
    telegram?: string
    whatsapp?: string
    skype?: string
    phone?: string
  }
}

onMounted(async () => {
  if (checkCancel())
    return;
  showMessage();
})

const uidValue = ref('');
const cookieName = computed(() => {
  return COOKIE_NAME + uidValue.value;
})

const onClosed = () => {
  rememberCancelForAwhile();
}

const rememberCancelForAwhile = () => {
  const ttl = moment().add(2, 'weeks');
  const ttlValue: string = ttl.valueOf() + '';
  if (localStorageSupported.value)
    localStorage.setItem(cookieName.value, ttlValue);
  Cookies.set(cookieName.value, ttlValue, {
    expires: ttl.toDate()
  });
}

const checkCancel = () => {
  let t: number;
  if (localStorageSupported.value) {
    t = +localStorage.getItem(cookieName.value) || 0;
  }
  if (!t) {
    t = +Cookies.get(cookieName.value) || 0;
  }
  // console.log('checkCancel', t, moment().valueOf());
  if (t && t > 0) {
    const r = t < moment().valueOf();
    if (r) {
      localStorage.removeItem(cookieName.value);
      Cookies.remove(cookieName.value);
    }
    return !r;
  } else
    return false;
}

// const rememberClose = () => {
//   if (localStorageSupported.value) {
//     localStorage.setItem(COOKIE_NAME, '1');
//   }
//   Cookies.set(COOKIE_NAME, '1');
// }

</script>

<i18n>
{
  "ru": {
    "title": "Снижение тарифов на Виртуальные карты USA Capitalist!"
  },
  "en": {
    "Напомнить позже": "Remind me later",
    "title": "Reduced fees for Capitalist Virtual cards USA!",
    "Выпуск карты": "Card issue",
    "Пополнение карты": "Card top-up",
    "Ежемесячное обслуживание": "Monthly maintenance",
    "Плата за транзакцию": "Transaction fee",
    "Закрыть": "Close"
  }
}
</i18n>

<style scoped lang="less">
dl {
  display: grid;
  grid-template-columns: max-content auto;
  grid-gap: 0.7em 3ex;
  margin: 0;
}
.striked {
  text-decoration: line-through;
  display: inline;
  color: #888888;
  margin-right: 1.5ex;
}
.new-contacts-pending-news-modal {
  .body-text {
    a {
      color: #80bd1c;
      text-decoration: underline;
    }
  }

  .modal-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
